import { render } from "./CertBizStats.vue?vue&type=template&id=453eff50&scoped=true"
import script from "./CertBizStats.vue?vue&type=script&lang=js"
export * from "./CertBizStats.vue?vue&type=script&lang=js"

import "./CertBizStats.vue?vue&type=style&index=0&id=453eff50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453eff50"]])

export default __exports__